module.exports = "<edit-header></edit-header>\n\n<div class=\"edit-management\">\n    <edit-csv-upload [driverGroups]=\"driverGroups\" [driverType]=\"driverType\"></edit-csv-upload>\n    <edit-es-flush [regions]=\"regions\"></edit-es-flush>\n    <edit-download-catalog [driverGroups]=\"driverGroups\" [driverType]=\"driverType\" [regions]=\"regions\"></edit-download-catalog>\n    <edit-family-labels [regions]=\"regions\"></edit-family-labels>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/management/management.component.html
// module id = ./src/app/management/management.component.html
// module chunks = main